import Spotlight from '/src/plugins/spotlight/js/spotlight.js';
import '/src/plugins/spotlight/css/spotlight.css';

Spotlight.init();

// document.addEventListener('spotlight.gallery.initiated', function(e){
//   console.log('spotlight.gallery.initiated', e.detail);
// })

// document.addEventListener('spotlight.gallery.closed', function(){
//   console.log('spotlight.gallery.closed');
// })

// document.addEventListener('spotlight.gallery.goto', function(e){
//   console.log('spotlight.gallery.goto', e.detail.slide);
// })

$('.slick.spotlight-group').slick({
  slidesToShow: 5,
  slidesToScroll: 4,
  infinite: false,
  centerMode: false,
  variableWidth: true,
  nextArrow: '<button type="button" class="arrow-next"><i class="fa-solid fa-angle-right"></i></button>',
  prevArrow: '<button type="button" class="arrow-prev"><i class="fa-solid fa-angle-left"></i></button>',
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 577,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});
